import React from 'react';
import { Helmet } from 'react-helmet';
import { ScrollToTop } from '../../common/scripts/scroll-to-top';
import { PictureBlock } from '../../common/elements/picture-block/picture-block';
import { ContentBlock } from '../../common/elements/content-block/content-block';
import { Paragraph } from '../../common/elements/paragraph/paragraph';
import { HomeAgenda } from '../../common/features/home-agenda/home-agenda';
import css from './home.module.scss';
import { ExternalLink } from '../../common/elements/external-link/external-link';
import { Link } from 'react-router-dom';

export const Home = () => {
    return (
        <ScrollToTop>
            <Helmet>
                <title>Nieuwezijds Gay Sauna Amsterdam</title>
                <meta
                    name="description"
                    content="The website of the Nieuwezijds Gay Sauna at the Nieuwezijds Armsteeg 95 in Amsterdam."
                />
            </Helmet>
            <section className={css.root}>
                <HomeAgenda />
                <PictureBlock isHome />
                <ContentBlock isHome position="2">
                    <Paragraph isHome promo>
                        Welcome to Sauna NZ
                    </Paragraph>

                    {/*   <Paragraph isHome promo>
                        Note: Our jacuzzi is temporarily closed due to
                        maintenance.
                    </Paragraph>*/}

                    <Paragraph isHome promo>
                        During World Pride Weekend (Friday 7th Aug - Sunday 9th
                        Aug) all entrance tickets are valid only for 6 hours.{' '}
                    </Paragraph>

                    <Paragraph isHome>
                        Need more time? Stay longer for just €5 per additional
                        hour.
                    </Paragraph>
                    <Paragraph isHome>
                        Thank you for your understanding, and have a great World
                        Pride! 🏳️‍🌈❤️
                    </Paragraph>

                    {/*<Paragraph isHome>
                        Amsterdam's award winning sauna for gay men, situated in
                        the heart of Amsterdam.
                    </Paragraph>*/}

                    <Paragraph isHome>
                        You can find our{' '}
                        <Link to="/info" style={{ color: '#6dcff6' }}>
                            opening hours
                        </Link>{' '}
                        here .<br />
                        Make sure you check out our{' '}
                        <Link to="/agenda" style={{ color: '#6dcff6' }}>
                            agenda
                        </Link>{' '}
                        for all our exciting weekly events.
                    </Paragraph>
                    {/*  <Paragraph isHome>
                        Featured event:
                        <br />
                        Come for a dance at our fantastic{' '}
                        <Link to="/agenda/tea-dance">Tea Dance</Link>, every
                        second Sunday of the month!
                    </Paragraph>*/}

                    <Paragraph isHome>Hope to see you soon!</Paragraph>

                    <Paragraph isHome>The NZ Team ❤️🌈</Paragraph>

                    <Paragraph isHome promo className={css.note}>
                        Attention everyone: Mpox is making a comeback in our
                        community. Inform yourself, get a vaccination,{' '}
                        <ExternalLink
                            href="https://www.mantotman.nl/nl/soas-hiv/alle-soas/mpox"
                            text="check out this page"
                        />
                        .
                    </Paragraph>

                    <Paragraph isHome promo className={css.note}>
                        PS: Have you visited our partner company{' '}
                        <ExternalLink
                            href="https://www.freewillie.nl/"
                            text="Free Willie"
                        />{' '}
                        yet? Pick up your complimentary ticket at NZ
                    </Paragraph>
                </ContentBlock>
            </section>
        </ScrollToTop>
    );
};
